import type {
  BaseQueryFn,
  TypedUseMutation,
  TypedUseQuery,
} from "@reduxjs/toolkit/query/react";

import { injectBillingEndpoints } from "../../../../core/store/reduxApi/billing";
import type {
  AutoTopupConfigResponse,
  AutoTopupDevToolsRequest,
  AutoTopupDevToolsResponse,
  CreatePortalSessionRequest,
  CreatePortalSessionResponse,
  ManualTopupChargeBody,
  ManualTopupChargeResponse,
  PlanSummaryResponse,
  PreviewInvoiceRequest,
  PreviewInvoiceResponse,
  UpdateAutoTopupConfigBody,
  UpdateAutoTopupConfigResponse,
  UpdateSubscriptionRequest,
  UpdateSubscriptionResponse,
} from "../../../../core/store/reduxApi/billing";
import { reduxApiSlice } from "./index";

export type {
  AutoTopupConfigResponse,
  AutoTopupDevToolsRequest,
  AutoTopupDevToolsResponse,
  AutoTopupDisableReason,
  BillingInterval,
  CreatePortalSessionRequest,
  CreatePortalSessionResponse,
  ManualTopupChargeBody,
  ManualTopupChargeResponse,
  PlanSummaryResponse,
  PreviewInvoiceRequest,
  PreviewInvoiceResponse,
  UpdateAutoTopupConfigBody,
  UpdateAutoTopupConfigResponse,
  UpdateSubscriptionRequest,
  UpdateSubscriptionResponse,
} from "../../../../core/store/reduxApi/billing";

const extendedApi = injectBillingEndpoints(reduxApiSlice);

export const useGetPlanSummaryQuery =
  extendedApi.useGetPlanSummaryQuery as TypedUseQuery<
    PlanSummaryResponse,
    void,
    BaseQueryFn
  >;
export const useUpdateSubscriptionMutation =
  extendedApi.useUpdateSubscriptionMutation as TypedUseMutation<
    UpdateSubscriptionResponse,
    UpdateSubscriptionRequest,
    BaseQueryFn
  >;
export const useCreatePortalSessionMutation =
  extendedApi.useCreatePortalSessionMutation as TypedUseMutation<
    CreatePortalSessionResponse,
    CreatePortalSessionRequest,
    BaseQueryFn
  >;
export const usePreviewInvoiceMutation =
  extendedApi.usePreviewInvoiceMutation as TypedUseMutation<
    PreviewInvoiceResponse,
    PreviewInvoiceRequest,
    BaseQueryFn
  >;
export const useGetAutoTopupConfigQuery =
  extendedApi.useGetAutoTopupConfigQuery as TypedUseQuery<
    AutoTopupConfigResponse,
    void,
    BaseQueryFn
  >;
export const useUpdateAutoTopupConfigMutation =
  extendedApi.useUpdateAutoTopupConfigMutation as TypedUseMutation<
    UpdateAutoTopupConfigResponse,
    UpdateAutoTopupConfigBody,
    BaseQueryFn
  >;
export const useManualTopupChargeMutation =
  extendedApi.useManualTopupChargeMutation as TypedUseMutation<
    ManualTopupChargeResponse,
    ManualTopupChargeBody,
    BaseQueryFn
  >;
// Auto-topup dev tools mutation — staging/EE only at runtime (server
// endpoint 404s on prod). Used by the AutoTopUpDevToolsModal.
export const useAutoTopupDevToolsMutation =
  extendedApi.useAutoTopupDevToolsMutation as TypedUseMutation<
    AutoTopupDevToolsResponse,
    AutoTopupDevToolsRequest,
    BaseQueryFn
  >;
